import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  title: '',
  isEdit: false,
  productName: '',
  productId: '',
  categoryObject: {},
  subCategoryObject: {},
  purchaseDate: '',
  warrantyDurationInDays: 0,
  serialNo: '',
  skuId: '',
  registrationChannel: '',
  registrationFlow: '',
  customerEmail: '',
  images: [],
  productDataLoading: false,
  productDataError: null,
  imagesLoading: false,
  imagesError: null,
  productDataSuccess: false,
  complaintProductData: null,
  complaintProductLoading: false,
  complaintProductError: null,
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProductDetail: (state, action) => {
      const {
        title,
        isEdit,
        productName,
        productId,
        categoryObject,
        subCategoryObject,
        purchaseDate,
        warrantyDurationInDays,
        serialNo,
        skuId,
        registrationChannel,
        registrationFlow,
        customerEmail,
      } = action.payload;
      state.title = title;
      state.isEdit = isEdit || false;
      state.productName = productName;
      state.productId = productId;
      state.categoryObject = categoryObject;
      state.subCategoryObject = subCategoryObject;
      state.purchaseDate = purchaseDate;
      state.warrantyDurationInDays = warrantyDurationInDays;
      state.serialNo = serialNo;
      state.skuId = skuId;
      state.registrationChannel = registrationChannel;
      state.registrationFlow = registrationFlow;
      state.customerEmail = customerEmail || '';
    },
    clearProductDetail: (state) => {
      state.title = '';
      state.isEdit = false;
      state.productName = '';
      state.productId = '';
      state.categoryObject = {};
      state.subCategoryObject = {};
      state.purchaseDate = '';
      state.warrantyDurationInDays = 0;
      state.serialNo = '';
      state.skuId = '';
      state.registrationChannel = '';
      state.registrationFlow = '';
      state.customerEmail = '';
    },
    setProductId: (state, action) => {
      // console.log('action.payload', action.payload);
      state.id = action.payload;
    },
    resetProductId: (state) => {
      state.id = '';
    },
    setProductData: (state, action) => {
      const data = action.payload;
      state.images = data.images || [];
      state.imagesLoading = false;
      state.imagesError = null;
    },
    clearProductData: (state) => {
      state.images = [];
      state.imagesLoading = false;
      state.imagesError = null;
    },
    setProductDataLoading: (state, action) => {
      state.productDataLoading = action.payload;
      if (action.payload) {
        state.imagesLoading = true;
        state.imagesError = null;
      }
    },
    clearProductDataLoading: (state) => {
      state.productDataLoading = false;
    },
    setProductDataError: (state, action) => {
      state.productDataError = action.payload;
      state.imagesLoading = false;
      state.imagesError = action.payload;
    },
    clearProductDataError: (state) => {
      state.productDataError = null;
    },
    setProductDataSuccess: (state, action) => {
      state.productDataSuccess = action.payload;
    },
    setComplaintProductData: (state, action) => {
      state.complaintProductData = action.payload;
      state.complaintProductLoading = false;
      state.complaintProductError = null;
    },
    setComplaintProductLoading: (state, action) => {
      state.complaintProductLoading = action.payload;
      if (action.payload) {
        state.complaintProductError = null;
      }
    },
    setComplaintProductError: (state, action) => {
      state.complaintProductError = action.payload;
      state.complaintProductLoading = false;
    },
    clearComplaintProductData: (state) => {
      state.complaintProductData = null;
      state.complaintProductLoading = false;
      state.complaintProductError = null;
    },
  },
});

export const {
  setProductDetail,
  clearProductDetail,
  setProductId,
  resetProductId,
  setProductData,
  clearProductData,
  setProductDataLoading,
  clearProductDataLoading,
  setProductDataError,
  clearProductDataError,
  setProductDataSuccess,
  setComplaintProductData,
  setComplaintProductLoading,
  setComplaintProductError,
  clearComplaintProductData,
} = productSlice.actions;
export default productSlice.reducer;
